import {BaseViewModel} from "../../../infrastructure/models/base-view-model";
import {GAME_STATUSES} from "../../../core/app/consts";
import {computed, observable} from "mobx";
import {GameCenterLinkModel} from "../../../containers/game-center-container/models/game-center.link-model";
import {PartialGameDomainModel} from "../../../domain/partial-game/models/partial-game-domain-model";
import {CompetitionViewModel} from "../../../domain/common/competition/models/competition-view-model";
import {GameCompetitorViewModel} from "../../../domain/partial-game/models/game-competitor/game-competitor-view-model";
import {OddsViewModel} from "../../../domain/common/odds/models/odds.view-model";
import {ODDS_TYPES} from "../../../core/components/odds/components/odds-consts";
import {GamesSliderWidgetTerms} from "../games-slider-widget.terms";
import {SportViewModel} from "../../../domain/sports/models/sport-view-model";
import {GameCenterHashParamsModel} from "../../../containers/game-center-container/models/game-center.hash-params-model";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";

export class GamesSliderWidgetGameViewModel extends BaseViewModel {
  domainModel: PartialGameDomainModel;
  terms: GamesSliderWidgetTerms;
  @observable date: String;
  @observable time: String;
  @observable oddsType: ODDS_TYPES;
  datetimeUtils: DatetimeUtils;

  constructor(partialGameViewModel: PartialGameDomainModel, date: String, time: String, oddsType: ODDS_TYPES, terms, datetimeUtils: DatetimeUtils) {
    super(partialGameViewModel);

    this.date = date;
    this.time = time;
    this.oddsType = oddsType;
    this.terms = terms;
    this.datetimeUtils = datetimeUtils;
  }

  @computed get hasOdds(): Boolean {
    return !!this.odds;
  }

  @computed get hasCurrentValidRates(): Boolean {
    let hasValidRates: Boolean = this.odds?.isValidCurrentRateOptions;

    return hasValidRates;
  }

  get linkModel(): GameCenterLinkModel {
    const hashParams: GameCenterHashParamsModel = new GameCenterHashParamsModel({id: this.id});
    const linkModel: GameCenterLinkModel = new GameCenterLinkModel(this.matchupId, this.competition.sport.nameForURL, this.competition.nameForURL, this.nameForUrl, hashParams, this.domainModel.isFollow);

    return linkModel;
  }

  @computed get matchupId(): Boolean {
    return this.domainModel.matchupId;
  }

  @computed get centerText() {
    const scoreTexts = {
      [GAME_STATUSES.anticipated]: '',
      [GAME_STATUSES.started]: this.hasScore ? this.scoreText : this.time,
      [GAME_STATUSES.ended]: this.hasScore ? this.scoreText : this.time,
      [GAME_STATUSES.scheduled]: this.time,
    }

    return scoreTexts[this.domainModel.statusGroup];
  }

  @computed get hasScore() {
    return this.domainModel.homeCompetitor.score !== -1;
  }

  @computed get scoreText(): String{
    return this.homeCompetitor.score + ' - ' + this.awayCompetitor.score;
  }

  @computed get statusText(): String{
    return this.domainModel.statusGroup === GAME_STATUSES.scheduled ? this.statusGameDate : this.domainModel.statusText;
  }

  @computed get competition(): CompetitionViewModel{
    return new CompetitionViewModel(this.domainModel.competition);
  }

  @computed get awayCompetitor(): GameCompetitorViewModel{
    return new GameCompetitorViewModel(this.domainModel.awayCompetitor);
  }

  @computed get homeCompetitor(): GameCompetitorViewModel{
    return new GameCompetitorViewModel(this.domainModel.homeCompetitor);
  }

  @computed get gameTimeDisplay(): String{
    return this.domainModel.gameTimeAndStatusText;
  }

  @computed get isLive(): Boolean{
    return this.domainModel.isLive;
  }

  @computed get isEnded(): Boolean{
    return this.domainModel.isEnded;
  }

  @computed get odds(): OddsViewModel {
    if (!this.domainModel.odds) {
      return null;
    }

    const odds: OddsViewModel = new OddsViewModel(this.domainModel.odds, this.oddsType);

    return odds;
  }

  get description() {
    return this.domainModel.winDescription;
  }

  @computed get statusGroup() {
    return this.domainModel.statusGroup;
  }

  get statusGameDate(): String {
    let gameTimeText = this.datetimeUtils.toShortNamedDate(this.domainModel.startTime);
    const showToday: Boolean = this.daysLeft === 0;
    const showTomorrow: Boolean = this.daysLeft === 1;

    if(showToday)
      gameTimeText = this.terms.WEB_MY_SCORES_TODAY_BUTTON
    else if(showTomorrow) {
      gameTimeText = this.terms.GAME_TIME_TOMORROW
    }

    return gameTimeText;
  }

  get daysLeft(): Number {
    const daysLeft: Number = this.datetimeUtils.diffDaysByDate(this.domainModel.startTime);

    return daysLeft;
  }

  get nameForUrl(): String {
    return this.domainModel.nameForUrl;
  }

  get aggregateText(): String {
    return this.terms.WEB_AGGREGATE_TEXT;
  }

  get aggregateScore(): String {
    return this.domainModel.aggregateScore;
  }

  get sport(): SportViewModel {
    return new SportViewModel(this.domainModel.sport);
  }
}
